import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  Col,
  Button,
  ButtonGroup,
  InputGroup,
  Dropdown,
  Form,
  Row,
  Tab,
  Tabs,
  ListGroup,
  Table,
  Modal,
} from "react-bootstrap";

const EmailBuilderHTML = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <main className="main overflow-hidden">
      <div className="formeditor-wrapper shadow-1 box-shadow-3">
        <div className="formeditor-header bg-white rounded-top d-flex justify-content-between align-items-center shadow-sm relative">
          <Button variant="editorclose border-0 bg-transparent border">
            <i className="bx bx-x bx-md"></i>
          </Button>
          <div className="headereditor-title border-start py-3 ps-3 w-100">
            <h3>Weekly Report Progress Project “Almanax”</h3>
            <div className="headereditor-sub-title d-flex align-items-center">
              <i className="bx bx-folder bx-xs me-1"></i> Email{" "}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-end w-100">
            <div className="unduredo-btns d-flex align-items-center py-3">
              <Button variant="action btn-sm px-1">
                <i className="bx bx-undo bx-sm"></i>
              </Button>
              <Button variant="action btn-sm px-1">
                <i className="bx bx-redo bx-sm"></i>
              </Button>
            </div>
            <div className="editor-action-btns ms-2 d-flex gap-2 align-items-center py-3 px-3">
              <Button variant="gray-light btn-sm bx-sm view-btn">
                <i className="bx bx-show-alt"></i>
              </Button>
              <Button variant="gray-light btn-sm">Save as template</Button>
              <Button variant="btn btn-secondary btn-sm">Send</Button>
            </div>
          </div>
        </div>
        <div className="d-flex rounded-bottom overflow-hidden bg-white rounded-bottom-3 formbuilder-body">
          <div className="w-20 px-2 py-4 bg-slate-50 border-end border-slate-200">
            <div className="d-flex flex-column row-gap-4">
              <button type="button" className="d-flex flex-column align-items-center row-gap-0 text-center border-0 bg-transparent text-slate-500">
                <span className="material-symbols-outlined">id_card</span>
                <span className="text-xs font-medium">Content</span>
              </button>
              <button type="button" className="d-flex flex-column align-items-center row-gap-0 text-center border-0 bg-transparent text-slate-500">
                <span className="material-symbols-outlined">settings</span>
                <span className="text-xs font-medium">Settings</span>
              </button>
              <button type="button" className="d-flex flex-column align-items-center row-gap-0 text-center border-0 bg-transparent text-slate-500">
                <span className="material-symbols-outlined">account_tree</span>
                <span className="text-xs font-medium">Condition</span>
              </button>
            </div>
          </div>
          <div className="formeditor-sidebar sidebar-left p-3 bg-white rounded-left-bottom-1 global-tab">
            <div className="search-div mb-3">
              <InputGroup>
                <InputGroup.Text>
                  <i className="pluto-search"></i>
                </InputGroup.Text>
                <Form.Control
                  type="search"
                  placeholder="Search element"
                />
              </InputGroup>
            </div>
            <div className="drag-buttons d-inline-flex flex-wrap gap-2">
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="material-symbols-outlined align-middle text-md">title</span> Title
              </div>
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="material-symbols-outlined align-middle text-md">notes</span> Text
              </div>
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="bx bx-code-alt align-middle bx-sm text-md"></span> HTML
              </div>
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="pluto-button text-md"></span> Button
              </div>
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="material-symbols-outlined">variables</span> Variable
              </div>
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="material-symbols-outlined">view_week</span> Column
              </div>
              <div className="btn btn-gray-light btn-sm border border-slate-300 d-flex align-items-center gap-1">
                <span className="material-symbols-outlined">imagesmode</span> Image
              </div>
            </div>
          </div>
          <div className="formeditor-view ms-auto sidebar-right p-3 border-end border-start h-100">
            <div className="p-3 rounded-2 bg-white border scroll-y">
              <div className="section-divider text-center mb-4">
                <span className="bg-white">Add section header</span>
              </div>
              <Row className="gy-4">
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="py-3 d-flex justify-content-start align-items-center gap-2">
                    <div className="d-flex align-items-center font-medium">Hello</div>
                    <Form.Select className="w-auto">
                      <option value="1">variable: user-name</option>
                      <option value="2">variable: user-email</option>
                    </Form.Select>
                  </div>
                  <p>Unlock endless possibilities with Pluto Edu! Our innovative platform simplifies the university application process, connecting you directly with top universities worldwide. Take the next step in your academic journey with ease and confidence.</p>
                  <img src="../assets/images/email-banner.jpg" alt="" className="w-100" />
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pe-4 position-relative">
                    <div className="drag-editor">
                      <textarea name="" id="" className="form-control border border-slate-300 rounded-3"></textarea>
                    </div>
                    <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">edit</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pe-4 position-relative">
                    <div className="drag-editor">
                      <div className="file-input-box bg-white border rounded">
                        <label for="file" className="d-block p-5 text-center">
                          <span className="material-symbols-outlined">
                            image
                          </span>
                          <h5 className="mb-0 text-sm text-slate-500">
                            <strong className="font-semibold">Choose file</strong> or{" "}
                            <strong className="font-semibold">Drag here</strong>
                          </h5>
                          <small>File size limit 20 MB</small>
                        </label>
                        <input type="file" id="file" className="d-none" />
                      </div>
                    </div>
                    <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">edit</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pe-4 position-relative">
                    <div className="drag-editor">
                      <div className="p-2 bg-white border rounded h-150">
                        <a href="#" style={{display:"inline-block", padding:"10px 20px", fontSize: "16px", textDecoration: "none", color:"#ffffff", borderRadius:"6px", backgroundColor:"#3B3B3B"}}>Button</a>
                      </div>
                    </div>
                    <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">edit</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pe-4 position-relative">
                    <div className="drag-editor">
                      <div className="p-2 bg-white border rounded h-150 pe-4">
                        <div className="g-3 row h-100">
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                            <div className="w-100 h-100 rounded border bg-white d-flex justify-content-center align-items-center">
                              <span className="text-base font-medium text-slate-500">Add element here</span>
                            </div>
                          </div>
                          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                            <div className="w-100 h-100 rounded border bg-white d-flex justify-content-center align-items-center">
                              <span className="text-base font-medium text-slate-500">Add element here</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">edit</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                    </div>
                  </div>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pe-4 position-relative">
                    <div className="drag-editor">
                      <div className="p-2 bg-white border rounded h-150 pe-4">
                        <Row className="g-3 row h-100">
                          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <div className=" w-100 h-100 rounded border bg-white d-flex justify-content-center align-items-center">
                              <span className="text-base font-medium text-slate-500">Add element here</span>
                            </div>
                          </Col>
                          <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                            <div className="w-100 h-100 rounded border bg-white d-flex justify-content-center align-items-center">
                              <span className="text-base font-medium text-slate-500">Add element here</span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">edit</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                    </div>
                  </div>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="pe-4 position-relative">
                    <div className="drag-editor">
                      <div className="p-2 bg-white border rounded h-150 pe-4">
                        <Row className="g-3 row h-100">
                          <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                            <div className=" w-100 h-100 rounded border bg-white d-flex justify-content-center align-items-center">
                              <span className="text-base font-medium text-slate-500">Add element here</span>
                            </div>
                          </Col>
                          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                            <div className="w-100 h-100 rounded border bg-white d-flex justify-content-center align-items-center">
                              <span className="text-base font-medium text-slate-500">Add element here</span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div className="position-absolute d-flex flex-column gap-2 drag-dit-delete-option">
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">edit</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center cursor-move"><span className="material-symbols-outlined">zoom_out_map</span></button>
                      <button className="border border-slate-300 rounded-2 bg-slate-50 w-8 h-8 d-flex justify-content-center align-items-center"><span className="material-symbols-outlined">delete</span></button>
                    </div>
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="drag-drop-box py-5 px-3 d-flex justify-content-center align-items-center rounded-2 bg-light h-auto">
                    Drag and drop elements to build your email
                  </div>
                </Col>

                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="text-center">
                    <Button variant="dark btn-lg" onClick={handleShow}>Visit this link</Button>
                    {/* <Button variant="primary btn-lg">Button Name</Button> */}
                  </div>
                </Col>
              </Row>

              {/* Modal */}
              <Modal show={show} size="xl" onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                  <Modal.Title>Form preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="global-tab">
                  <Tabs
                    defaultActiveKey="desktop"
                    id="uncontrolled-tab-example"
                    className="mb-3 preview-tab"
                  >
                    <Tab
                      eventKey="desktop"
                      title={
                        <span>
                          <span className="material-symbols-outlined display-icon mb-1">
                            desktop_windows
                          </span>
                          Desktop
                        </span>
                      }
                    >
                      <div className="relative text-content">
                        <div className="display-img display-desktop text-center">
                          <img src="/assets/images/desktop-display.svg" alt="" />
                        </div>
                        <div className="display-view desktop-view">
                          <div className="p-4">
                            <Row>
                              <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <div className="py-3 d-flex justify-content-start align-items-center gap-2">
                                  <div className="d-flex align-items-center font-medium">Hello</div>
                                  <Form.Select className="w-auto">
                                    <option value="1">variable: user-name</option>
                                    <option value="2">variable: user-email</option>
                                  </Form.Select>
                                </div>

                                <p>Unlock endless possibilities with Pluto Edu! Our innovative platform simplifies the university application process, connecting you directly with top universities worldwide. Take the next step in your academic journey with ease and confidence.</p>

                                <img src="../assets/images/email-banner.jpg" alt="" className="w-100" />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="tablet"
                      title={
                        <span>
                          <span className="material-symbols-outlined display-icon mb-1">
                            tablet_mac
                          </span>
                          Tablet
                        </span>
                      }
                    >
                      <div className="relative text-content">
                        <div className="display-img display-tablet text-center">
                          <img src="/assets/images/tablet-display.svg" alt="" />
                        </div>
                        <div className="display-view tablet-view">
                          <div className="p-4">
                            <Row>
                              <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <div className="py-3 d-flex justify-content-start align-items-center gap-2">
                                  <div className="d-flex align-items-center font-medium">Hello</div>
                                  <Form.Select className="w-auto">
                                    <option value="1">variable: user-name</option>
                                    <option value="2">variable: user-email</option>
                                  </Form.Select>
                                </div>

                                <p>Unlock endless possibilities with Pluto Edu! Our innovative platform simplifies the university application process, connecting you directly with top universities worldwide. Take the next step in your academic journey with ease and confidence.</p>

                                <img src="../assets/images/email-banner.jpg" alt="" className="w-100" />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="mobile"
                      title={
                        <span>
                          <span className="material-symbols-outlined display-icon mb-1">
                            smartphone
                          </span>
                          Mobile
                        </span>
                      }
                    >
                      <div className="relative text-content">
                        <div className="display-img display-mobile text-center">
                          <img src="/assets/images/mobile-display.svg" alt="" />
                        </div>
                        <div className="display-view mobile-view">
                          <div className="p-4">
                            <Row>
                              <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <div className="py-3 d-flex justify-content-start align-items-center gap-2">
                                  <div className="d-flex align-items-center font-medium">Hello</div>
                                  <Form.Select className="w-auto">
                                    <option value="1">variable: user-name</option>
                                    <option value="2">variable: user-email</option>
                                  </Form.Select>
                                </div>

                                <p>Unlock endless possibilities with Pluto Edu! Our innovative platform simplifies the university application process, connecting you directly with top universities worldwide. Take the next step in your academic journey with ease and confidence.</p>

                                <img src="../assets/images/email-banner.jpg" alt="" className="w-100" />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Tab>
                  </Tabs>
                </Modal.Body>
              </Modal>
            </div>
          </div>
          <div className="formeditor-sidebar ms-auto sidebar-right bg-white global-tab h-100">
            <div className="p-3 h-100 d-flex flex-column">
              <div className="mb-2">
                <h3 className="text-base font-semibold text-slate-600">Title</h3>
              </div>
              <div className="tab-content">
                <div className="mb-4">
                  <div className="mb-2">
                    <h3 className="text-base font-semibold text-slate-600">Title settings</h3>
                  </div>
                  <Row className="gy-4">
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div className="p-3 border border-slate-200 rounded-3 text-sm font-semibold text-slate-500">Text Editor</div>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-2 text-sm font-semibold text-slate-600">Font Size</div>
                      <div>
                        <select name="fontSize" id="" className="form-select text-sm">
                          <option value="1">8</option>
                          <option value="1">10</option>
                          <option value="1">12</option>
                          <option value="1">14</option>
                          <option value="1">16</option>
                          <option value="1">18</option>
                          <option value="1">20</option>
                        </select>
                      </div>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-2 text-sm font-semibold text-slate-600">Text align</div>
                      <div>
                        <div className="d-flex flex-wrap gap-2">
                          <input type="radio" className="btn-check" name="options" id="option1" />
                          <label className="btn btn-outline-slate" for="option1"><span className="material-symbols-outlined">format_align_left</span></label>

                          <input type="radio" className="btn-check" name="options" id="option2" />
                          <label className="btn btn-outline-slate" for="option2"><span className="material-symbols-outlined">format_align_center</span></label>

                          <input type="radio" className="btn-check" name="options" id="option3" />
                          <label className="btn btn-outline-slate" for="option3"><span className="material-symbols-outlined">format_align_right</span></label>
                        </div>
                      </div>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-2 text-sm font-semibold text-slate-600">Line height</div>
                      <div>
                        <select name="fontSize" id="" className="form-select text-sm">
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                        </select>
                      </div>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-sm font-semibold text-slate-600">Text color</div>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-10 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-sm font-semibold text-slate-600">Background color</div>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-10 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div className="mb-2 text-sm font-semibold text-slate-600">Padding</div>
                      <Row className="g-3">
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-xs font-semibold text-slate-600">Top</div>
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="0" />
                            <span className="input-group-text" id="top">px</span>
                          </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-xs font-semibold text-slate-600">Bottom</div>
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="0" />
                            <span className="input-group-text" id="bottom">px</span>
                          </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-xs font-semibold text-slate-600">Left</div>
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="0" />
                            <span className="input-group-text" id="left">px</span>
                          </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-xs font-semibold text-slate-600">Right</div>
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="0" />
                            <span className="input-group-text" id="right">px</span>
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                      <Row>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-sm font-semibold text-slate-600">Border width</div>
                          <div className="input-group">
                            <input type="text" className="form-control" placeholder="0" />
                            <span className="input-group-text" id="top">px</span>
                          </div>
                        </Col>
                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                          <div className="mb-2 text-sm font-semibold text-slate-600">Border color</div>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-10 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                <hr />

                <div className="mb-4">
                  <div className="mb-2">
                    <h3 className="text-base font-semibold text-slate-600">Button Settings</h3>
                  </div>
                  
                  <div className="mb-3 file-input-box bg-white border rounded">
                    <textarea name="" id="" className="form-control"></textarea>
                  </div>
                
                  <div className="mb-3 input-sm">
                    <label for="imageUrl" className="form-label">Button Link</label>
                      <input type="url" name="imageUrl" id="imageUrl" className="form-control text-sm" placeholder="www.google.com/image/picture_of_form" />
                  </div>
                
                  <div className="mb-3 input-sm">
                    <label for="fontSize" className="form-label">Font Size</label>
                    <select name="fontSize" id="fontSize" className="form-select text-sm">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </select>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="lineHeight2" className="form-label">Line height</label>
                    <select name="lineHeight2" id="" className="form-select text-sm">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                    </select>
                  </div>
                
                  <div className="mb-3 input-sm">
                    <label for="buttonAlign" className="form-label">Button align</label>
                    <div>
                      <div className="d-flex flex-wrap gap-2">
                        <input type="radio" className="btn-check" name="buttons" id="button1" />
                        <label className="btn btn-outline-slate" for="button1"><span className="material-symbols-outlined">format_align_left</span></label>

                        <input type="radio" className="btn-check" name="buttons" id="button2" />
                        <label className="btn btn-outline-slate" for="button2"><span className="material-symbols-outlined">format_align_center</span></label>

                        <input type="radio" className="btn-check" name="buttons" id="button3" />
                        <label className="btn btn-outline-slate" for="button3"><span className="material-symbols-outlined">format_align_right</span></label>
                      </div>
                    </div>
                  </div>                      

                  <div className="mb-3 input-sm">
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="input-sm">
                          <label className="form-label">Text color</label>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="input-sm">
                          <label className="form-label">Background color</label>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-3 input-sm">
                    <label className="form-label">Padding</label>
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Top</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="top">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Bottom</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="bottom">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Left</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="left">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Right</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="right">px</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-3 input-sm">
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Border width</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="top">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Border color</label>
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                            <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                          </div>
                          <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                <hr />
                <div className="mb-4">
                  <div className="mb-2">
                    <h3 className="text-base font-semibold text-slate-600">Image settings</h3>
                  </div>
                  
                  <div className="mb-3 file-input-box bg-white border rounded">
                    <label for="file" className="d-block p-4 text-center">
                      <span className="material-symbols-outlined">
                        image
                      </span>
                      <h5 className="mb-0 text-sm text-slate-500">
                        <strong className="font-semibold">Choose file</strong> or{" "}
                        <strong className="font-semibold">Drag here</strong>
                      </h5>
                      <small>File size limit 20 MB</small>
                    </label>
                    <input type="file" id="file" className="d-none" />
                  </div>
                
                  <div className="mb-3 input-sm">
                    <label for="fontSize" className="form-label">Font Size</label>
                    <select name="fontSize" id="fontSize" className="form-select text-sm">
                      <option value="1">8</option>
                      <option value="1">10</option>
                      <option value="1">12</option>
                      <option value="1">14</option>
                      <option value="1">16</option>
                      <option value="1">18</option>
                      <option value="1">20</option>
                    </select>
                  </div>
                
                  <div className="mb-3 input-sm">
                    <label for="imageUrl" className="form-label">Image URL</label>
                      <input type="url" name="imageUrl" id="imageUrl" className="form-control text-sm" placeholder="www.google.com/image/picture_of_form" />
                  </div>
                
                  <div className="mb-3 input-sm">
                    <label for="altText" className="form-label">ALT text</label>
                    <input type="text" name="altText" id="altText" className="form-control text-sm" placeholder="Image of adverstisement" />
                  </div>

                  <div className="mb-3 input-sm">
                    <div className="form-check form-switch form-switch-lg d-flex justify-content-between form-switch-right form-switch-success mb-1">
                      <label
                        className="form-check-label"
                        for="FiledLength"
                      >
                        Image redirect link
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="FiledLength"
                      />
                    </div>

                    <input type="text" name="" id="" className="form-control text-sm" placeholder="www.google.com" />
                  </div>
                  
                  <div className="mb-3 input-sm">
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="input-sm">
                          <label className="form-label">Text color</label>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="input-sm">
                          <label className="form-label">Background color</label>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-3 input-sm">
                    <label className="form-label">Padding</label>
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Top</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="top">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Bottom</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="bottom">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Left</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="left">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Right</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="right">px</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-3 input-sm">
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Border width</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="top">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Border color</label>
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                            <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                          </div>
                          <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                <hr />
                <div className="mb-4">
                  <div className="mb-2">
                    <h3 className="text-base font-semibold text-slate-600">Coulmn settings</h3>
                  </div>

                  <div className="mb-3 input-sm">
                    <label for="fontSize" className="form-label">Column number</label>
                    <select name="fontSize" id="fontSize" className="form-select text-sm">
                      <option value="1">1</option>
                      <option value="1">2</option>
                      <option value="1">3</option>
                      <option value="1">4</option>
                      <option value="1">6</option>
                    </select>
                  </div>

                  <div className="mb-3 input-sm">
                    <label className="form-label">Column Type</label>
                    <div>
                      <Row className="g-2">
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={6}>
                          <div className="p-1 border rounded-1 bg-slate-100">
                            <Row className="g-1">
                              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                <div className="w-100 h-10 border bg-white d-flex justify-content-center align-items-center">
                                  <span className="text-xs font-medium text-slate-500">50%</span>
                                </div>
                              </Col>
                              <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                                <div className="w-100 h-10 border bg-white d-flex justify-content-center align-items-center">
                                  <span className="text-xs font-medium text-slate-500">50%</span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={6}>
                          <div className="p-1 border rounded-1 bg-slate-100">
                            <Row className="g-1">
                              <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <div className="w-100 h-10 border bg-white d-flex justify-content-center align-items-center">
                                  <span className="text-xs font-medium text-slate-500">25%</span>
                                </div>
                              </Col>
                              <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                                <div className="w-100 h-10 border bg-white d-flex justify-content-center align-items-center">
                                  <span className="text-xs font-medium text-slate-500">75%</span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={6}>
                          <div className="p-1 border rounded-1 bg-slate-100">
                            <Row className="g-1">
                              <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={8}>
                                <div className="w-100 h-10 border bg-white d-flex justify-content-center align-items-center">
                                  <span className="text-xs font-medium text-slate-500">75%</span>
                                </div>
                              </Col>
                              <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                <div className="w-100 h-10 border bg-white d-flex justify-content-center align-items-center">
                                  <span className="text-xs font-medium text-slate-500">25%</span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  
                  <div className="mb-3 input-sm">
                    <Row className="g-2">
                      {/* <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="input-sm">
                          <label className="form-label">Text color</label>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </div>
                      </Col> */}
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <div className="input-sm">
                          <label className="form-label">Background color</label>
                          <div className="d-flex align-items-center gap-2">
                            <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                              <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                            </div>
                            <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-3 input-sm">
                    <label className="form-label">Padding</label>
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Top</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="top">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Bottom</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="bottom">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Left</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="left">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Right</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="right">px</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="mb-3 input-sm">
                    <Row className="g-2">
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Border width</label>
                        <div className="input-group">
                          <input type="text" className="form-control" placeholder="0" />
                          <span className="input-group-text" id="top">px</span>
                        </div>
                      </Col>
                      <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6}>
                        <label className="form-label">Border color</label>
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-none w-9 h-9 rounded-2 border border-slate-300 bg-slate-100">
                            <input type="color" className="w-100 h-100 border border-slate-300 rounded-1" />
                          </div>
                          <div className="w-100 h-9 p-2 d-flex align-items-center text-sm text-slate-500 rounded-2 border border-slate-300 bg-slate-50">#0f172a</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                
              </div>

              <div className="mt-3 d-grid gap-2">
                <Button variant="green">
                  <i className="bx bx-save bx-sm align-middle"></i> Save Change
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default EmailBuilderHTML;
